import React, { useState } from 'react';
import { JoykitIcon } from '@components/JoykitIcon';
import TestimonialCarouselItem from './TestimonialCarouselItem/TestimonialCarouselItem';
import { NextSlideButton, PreviousSlideButton, StyledCarousel } from './TestimonialsCarousel.styles';

interface Testimonial {
  title: string;
  author: string;
  imagePath: string;
  readMoreContent?: string;
}

interface TestimonialsCarouselProps {
  testimonialsData: Testimonial[];
}

export const TestimonialsCarousel: React.FC<TestimonialsCarouselProps> = ({ testimonialsData }) => {
  const [expandedSlideIndex, setExpandedSlideIndex] = useState<number | null>(null);

  const toggleExpanded = (index: number) => (expandedSlideIndex === index ? setExpandedSlideIndex(null) : setExpandedSlideIndex(index));
  return (
    <StyledCarousel
      wrapAround
      renderCenterLeftControls={({ previousSlide }) => (
        <PreviousSlideButton aria-label="Previous Slide Button" onClick={previousSlide} id="registry-shop-prev-btn">
          <JoykitIcon name="backChevron" color="mono1" size={24} />
        </PreviousSlideButton>
      )}
      renderCenterRightControls={({ nextSlide }) => (
        <NextSlideButton aria-label="Next Slide Button" onClick={nextSlide} id="regsitry-shop-next-btn">
          <JoykitIcon name="forwardChevron" color="mono1" size={24} />
        </NextSlideButton>
      )}
      renderBottomCenterControls={null}
      afterSlide={() => setExpandedSlideIndex(null)}
    >
      {testimonialsData?.map((testimonial, index) => (
        <TestimonialCarouselItem
          key={index}
          testimonialData={testimonial}
          isExpanded={expandedSlideIndex === index}
          toggleExpanded={() => toggleExpanded(index)}
        />
      ))}
    </StyledCarousel>
  );
};
